/**
 * The `agent_template` seed, **generated from the catalogue** (unit P7-01).
 *
 * `agent_template` is a platform table with no `account_id`, so its rows arrive in a
 * migration. That leaves the usual hazard: the migration and the TypeScript catalogue are two
 * copies of one list, and copies drift. So there is one copy — `./agent-template-catalogue.ts`
 * — and this module renders it as SQL. `agent-template-catalogue.test.ts` asserts that the
 * latest survey field publication matches the compiled catalogue; the database suite verifies
 * the resulting rows after all migrations. AMENDED 2026-10-04: 0006 remains immutable, and
 * 0073 publishes the revised survey fields. This full seed is for a fresh catalogue only.
 * AMENDED 2026-10-09 (plan-015 CAT, G7): the seed names `direction`, the column 0118 adds NOT NULL; 0118
 * itself is emitted by `tools/catalogue-emit` from a frozen publication, not from this module.
 *
 * The statement is an upsert on `code`, which is the table's natural key, because a migration
 * may be applied to a database that a previous environment already seeded.
 */
import { AGENT_TEMPLATE_CATALOGUE } from "./agent-template-catalogue.js";
/** Escapes a value for a single-quoted SQL literal. Doubling the quote is the whole rule. */
function literal(value) {
    return `'${value.replaceAll("'", "''")}'`;
}
function json(value) {
    return `${literal(JSON.stringify(value))}::jsonb`;
}
function rowOf(one) {
    return [
        `  (${literal(one.agentTemplateId)}`,
        literal(one.code),
        literal(one.name),
        literal(one.dek),
        literal(one.youAdd),
        literal(one.icon),
        one.available ? "true" : "false",
        literal(one.contentTitle),
        literal(one.contentDek),
        json(one.fieldSet),
        literal(one.defaultGreeting),
        literal(one.defaultName),
        json(one.outcomeVocabulary),
        literal(one.successMetricLabel),
        json(one.script),
        literal(one.referenceSchema),
        `${literal(one.direction)})`,
    ].join(",\n   ");
}
/** The `INSERT … ON CONFLICT (code) DO UPDATE` that seeds the catalogue. */
export const AGENT_TEMPLATE_SEED_SQL = `INSERT INTO agent_template
  (agent_template_id, code, name, dek, you_add, icon, available, content_title, content_dek,
   field_set, default_greeting, default_name, outcome_vocabulary, success_metric_label, script,
   reference_schema, direction)
VALUES
${AGENT_TEMPLATE_CATALOGUE.map(rowOf).join(",\n")}
ON CONFLICT (code) DO UPDATE SET
  name = EXCLUDED.name,
  dek = EXCLUDED.dek,
  you_add = EXCLUDED.you_add,
  icon = EXCLUDED.icon,
  available = EXCLUDED.available,
  content_title = EXCLUDED.content_title,
  content_dek = EXCLUDED.content_dek,
  field_set = EXCLUDED.field_set,
  default_greeting = EXCLUDED.default_greeting,
  default_name = EXCLUDED.default_name,
  outcome_vocabulary = EXCLUDED.outcome_vocabulary,
  success_metric_label = EXCLUDED.success_metric_label,
  script = EXCLUDED.script,
  reference_schema = EXCLUDED.reference_schema,
  direction = EXCLUDED.direction;`;
//# sourceMappingURL=agent-template-seed.js.map